import { action } from "../common/Action"
import { ContrattiClient, Contratto } from "../generated";

const service = new ContrattiClient();

class ContrattiActions {
    @action
    async getByImpianto(idImpianto: number) {
        return {
            idImpianto,
            contratti: (await service.getContrattiImpianto(idImpianto))!,
        }
    };
    @action
    async add(contratto: Contratto) {
        await service.addContratto(contratto);
        return { idImpianto: contratto.idImpianto, contratti: (await service.getContrattiImpianto(contratto.idImpianto))! };
    }
    @action
    async update(contratto: Contratto) {
        await service.updateContratto(contratto);
        return { idImpianto: contratto.idImpianto, contratti: (await service.getContrattiImpianto(contratto.idImpianto))! };
    }
    @action
    async delete(contratto: Contratto) {
        await service.deleteContratto(contratto.id);
        return { idImpianto: contratto.idImpianto, contratti: (await service.getContrattiImpianto(contratto.idImpianto))! };
    }
}
export default new ContrattiActions();